/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('TrombiCtrl', function($scope, $location, identity, Trombi, Term, ErrorThrower) {
    $scope.term_list    = [];
    $scope.trombi       = [];
    $scope.current_term = { };
    $scope.profs        = { };
    $scope.location     = $location;
    $scope.me           = identity;
    const error_msg           = 'Une erreur est survenue lors de la récupération $item$, veuillez réessayer ultérieurement.';
    const errorManager        = ErrorThrower({
        'Erreur de récupération des terms':        error_msg.replace('$item$', 'des promotions'),
        'Erreur de récupération du term en cours': error_msg.replace('$item$', 'du term en cours'),
        'Erreur de récupération des étudiants':    error_msg.replace('$item$', 'des étudiants'),
        'Erreur de récupération des profs':        error_msg.replace('$item$', 'des profs')
    });

    $scope.setProfs = function() {
        $scope.current_term = null;
        $location.search({ 'profs': 'profs' });
        return Trombi
        .getProfs()
        .$promise
        .then(profs => $scope.profs = profs).catch(() => errorManager.minor('Erreur de récupération des profs'));
    };

    $scope.printTerm = function() {
        const popup = window.open('', '_blank', 'width=600,height=600');
        popup.document.open;
        for (let student of Array.from($scope.trombi.students)) {
            popup.document.write('<span>' + student.login + '</span><br>');
        }
        return popup.document.close();
    };

    const findCurrentTerm = function(terms) {
        for (let term of Array.from(terms)) {
            const now   = new Date;
            const start = new Date(term.learning_start);
            const end   = new Date(term.learning_end);
            if ((now >= start) && (now <= end)) { return term; }
        }
    };

    $scope.setTerm = id => Trombi
    .getTrombiByTerm({
        term_id: id})
    .$promise
    .then(function(trombi) {
        $scope.trombi       = trombi;
        $scope.current_term = trombi.term;
        return $location.search({ id: $scope.current_term.id });})
    .catch(() => errorManager.minor('Erreur de récupération des étudiants'));

    const init = function() {
        if (Array.from($scope.me.groups).includes('student')) {
            return Term
            .query({
                login: $scope.me.login})
            .$promise
            .then(function(terms) {
                $scope.current_term = findCurrentTerm(terms);
                $location.search({ id: $scope.current_term.id });
                return $scope.setTerm($scope.current_term.id);}).catch(() => errorManager.minor('Erreur de récupération du term en cours'));
        } else {
            return $scope.setProfs();
        }
    };

    Trombi
    .getTermsForTrombi()
    .$promise
    .then(term_list => $scope.term_list = term_list).catch(() => errorManager.minor('Erreur de récupération des terms'));

    if ($location.search().id != null) {
        return $scope.setTerm($location.search().id);
    } else {
        return init();
    }
});
